import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip, Dropdown, Button } from 'antd';
import { notificationConstants } from '../../../../constants/notification.constants';
import { setFilterVisible } from '../../store/actions';
import FilterDropdownMenu from '../FilterDropdownMenu/FilterDropdownMenu';
import styles from './FilterDropdown.module.scss';

const FilterDropdown = () => {
  const dispatch = useDispatch();

  const handleFilterBtnClick = () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });
    dispatch(setFilterVisible(true));
  };

  return (
    <Tooltip title="Фильтр" placement="left">
      <Dropdown overlay={<FilterDropdownMenu />} placement="bottomLeft">
        <Button
          className={styles.filterBtn}
          icon="filter"
          onClick={handleFilterBtnClick}
        />
      </Dropdown>
    </Tooltip>
  );
};

export default FilterDropdown;
